import { State, PRODUCTS_FEATURE_KEY } from './products.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectProductsState = createFeatureSelector<State>(
  PRODUCTS_FEATURE_KEY
);
export const selectProductDetails = createSelector(
  selectProductsState,
  state => state.productDetails
);

// return true if any of the objects under products has loading attribute to true
export const isLoading = createSelector(selectProductsState, state =>
  Object.keys(state).some(key => state[key].loading)
);
